import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    inputSearch: {
      type: Boolean,
      default: false,
    },
    searchKeyword: {
      type: String,
    },
  },
  data() {
    return {
      keyword: null,
    };
  },
  watch: {
    searchKeyword: {
      immediate: true,
      handler(to) {
        this.keyword = to;
      },
    },
    keyword(to) {
      if (this.inputSearch === true) {
        this.filterTree(to);
      }
    },
  },
  methods: {
    filterTree(keyword) {
      if (this.$refs[this.treeRef]) {
        this.$refs[this.treeRef].filter(keyword);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      if (isEmpty(data.ipaddress)) {
        return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      }

      // IP 정보가 있는 경우 IP도 함께 검색한다.
      const keyword = value.toLowerCase();
      return data.label.toLowerCase().indexOf(keyword) !== -1 || (!isEmpty(data.ipaddress) && data.ipaddress.toLowerCase().indexOf(keyword) !== -1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/tree/filter.js